import type { AssetConditionRatingFieldOptionItem } from "./asset-condition-rating-field.type";

import { useReferentialConditionRatings } from "@/entities/referential/referential-condition-ratings";

export const useAssetConditionRatingField = () => {
  const { conditionRatings, isLoading } = useReferentialConditionRatings();

  const options = conditionRatings.map(
    (condition): AssetConditionRatingFieldOptionItem => ({
      label: condition.name,
      value: condition.rating,
      color: condition.color,
    })
  );

  return {
    options,
    isLoading,
  };
};
